import { TaskDto } from './dto/task.dto';
import { ApiService, PagedResultGeneric } from 'src/app/shared';
import { Injectable } from '@angular/core';
import { TaskSearchDto } from './dto/task-search.dto';
import { ProfileServiceApiService } from 'src/app/shared/api/profile-service-api.service';

@Injectable({
  providedIn: 'root',
})
export class TaskService {
  constructor(private _apiService: ApiService, private _profileServiceApiService: ProfileServiceApiService) {}

  search(searchDto: TaskSearchDto): Promise<PagedResultGeneric<TaskDto>> {
    return this._profileServiceApiService.postPaged(`profile/v2/Task/Search`, searchDto);
  }

  getMyTasks(searchDto: TaskSearchDto, forceRefresh = false) {
    let cacheOptions;
    if (forceRefresh) {
      cacheOptions = this._apiService.getDefaultApiCacheOptionsForNoCache();
    } else {
      cacheOptions = this._apiService.getDefaultApiCacheOptionsForFrequentlyChangedData();
    }
    return this._apiService.getPaged('Tasks/MyTasks', searchDto, cacheOptions);
  }

  getProfileTasks(profileId: number, searchParams: TaskSearchDto = null, forceRefresh = false) {
    return this._profileServiceApiService.postPaged(`profile/v2/${profileId}/Tasks`, searchParams);
  }

  get(id: number): Promise<TaskDto> {
    return this._apiService.get(`Task/${id}`);
  }

  create(task: TaskDto): Promise<number> {
    return this._apiService.post('Tasks', task);
  }

  update(task: TaskDto): Promise<void> {
    return this._apiService.put(`Task/${task.TaskId}`, task);
  }

  delete(id: number): Promise<void> {
    return this._apiService.delete(`Task/${id}`);
  }

  exportTasks(searchDto: TaskSearchDto) {
    return this._profileServiceApiService.post(`profile/v2/Task/export-search`, searchDto);
  }
}
